import {
  AfterContentInit,
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  OnDestroy,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {StepperModule} from 'primeng/stepper';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {BillingPackage, PackageSelectItemComponent} from './package-select-item/package-select-item.component';
import {Subscription} from 'rxjs';


@Component({
  selector: 'ibp-package-select',
  templateUrl: './package-select.component.html',
  styleUrls: ['./package-select.component.scss'],
  standalone: true,
  imports: [
    StepperModule,
    ReactiveFormsModule,
    PackageSelectItemComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PackageSelectComponent),
      multi: true,
    }
  ]
})
export class PackageSelectComponent implements ControlValueAccessor, AfterContentInit, OnDestroy, AfterViewInit {
  @Input() public name: string = '';
  @Input() public disabled = false;
  @Input() public unselectable = false;
  @Input() public packageTitle = '';
  @Input() public packageCostTitle = '';
  @Input() public packageAdditionalCostTitle = '';
  @Input() public billingPackages: BillingPackage[];
  private _value: any = null;
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};
  private subscriptions: Subscription = new Subscription();

  @ViewChildren(PackageSelectItemComponent, {}) packageItems!: QueryList<PackageSelectItemComponent>;

  ngAfterContentInit() {
  }
  ngAfterViewInit() {
    this.updateItemStates();
    this.subscribeToItemChanges();
    this.subscriptions.add(
      this.packageItems.changes.subscribe(() => {
        this.updateItemStates();
        this.subscribeToItemChanges();
      })
    )
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  writeValue(value: any) {
    this._value = value;
    this.updateItemStates();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.updateItemStates();
  }

  private updateItemStates() {
    if (this.packageItems) {
      this.packageItems.forEach(item => {
        item.selected = item.billingPackage.packageSize === this._value;
        item.disabled = this.disabled;
      })
    }
  }

  private subscribeToItemChanges() {
    this.subscriptions.unsubscribe();
    this.subscriptions = new Subscription();
    if (this.packageItems) {
      this.packageItems.forEach(item => {
        this.subscriptions.add(
          item.select.subscribe((selectedValue) => {
            if (!this.disabled) {
              if (this._value === selectedValue && this.unselectable) {
                this._value = null;
              } else {
                this._value = selectedValue;
              }
              this.onChange(this._value);
              this.onTouched();
              this.updateItemStates();
            }
          })
        )
      })
    }
  }
}
